(() => {
  const sliderSelector = '[data-okg-price-slider]';
  const minRangeSelector = '[data-okg-price-min-range]';
  const maxRangeSelector = '[data-okg-price-max-range]';

  const formatPriceInputValue = (cents) => {
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';

    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const cleanPriceInputValue = (value) => {
    const normalized = String(value || '').replace(/[^0-9.,]/g, '').replace(/\.00$/, '');
    if (!normalized.includes('.')) return normalized;

    return normalized.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
  };

  const syncCollectionStyleNav = () => {
    const styleItems = document.querySelectorAll('.okg-collection-style-nav__item[data-okg-filter-name]');
    if (!styleItems.length) return;

    const searchParams = new URLSearchParams(window.location.search);

    styleItems.forEach((item) => {
      const selectedValues = searchParams.getAll(item.dataset.okgFilterName);
      item.classList.toggle('is-active', selectedValues.includes(item.dataset.okgFilterValue));
    });
  };

  const renderFacetUrl = (url, event) => {
    if (typeof FacetFiltersForm === 'undefined' || url.pathname !== window.location.pathname) {
      window.location.href = url.href;
      return;
    }

    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(url.searchParams.toString(), event);
  };

  document.addEventListener('click', (event) => {
    const styleItem = event.target.closest('a.okg-collection-style-nav__item[data-okg-filter-name]');
    if (!styleItem) return;

    event.preventDefault();
    renderFacetUrl(new URL(styleItem.href, window.location.origin), event);
  });

  const syncMissingFilterInputValues = () => {
    document
      .querySelectorAll(
        [
          '#FacetFiltersFormMobile input.mobile-facets__checkbox[name="filter.p.m.custom.style"]',
          '#FacetFiltersFormMobile input.mobile-facets__checkbox[name="filter.v.option.metal type"]',
          '#FacetFiltersFormMobile input.mobile-facets__checkbox[name="filter.p.m.custom.center_diamond_shape"]',
          '#FacetFiltersFormMobile input.mobile-facets__checkbox[name="filter.p.m.custom.stone_shape"]',
        ].join(','),
      )
      .forEach((input) => {
        if (input.getAttribute('value')) return;

        const label =
          input.closest('label')?.querySelector('.facet-checkbox__text-label')?.textContent?.trim() || '';
        if (!label) return;

        input.value = label;
        input.setAttribute('value', label);
      });
  };

  const cleanPriceInputs = (slider) => {
    const ranges = [slider.querySelector(minRangeSelector), slider.querySelector(maxRangeSelector)].filter(Boolean);
    ranges.forEach((range) => {
      const target = document.getElementById(range.dataset.okgPriceTarget);
      if (target) target.value = cleanPriceInputValue(target.value);
    });
  };

  const updateSliderTrack = (slider, minRange, maxRange) => {
    const max = Number(maxRange.max) || 1;
    const minValue = Number(minRange.value) || 0;
    const maxValue = Number(maxRange.value) || max;

    slider.style.setProperty('--okg-min-percent', `${Math.max(0, Math.min(100, (minValue / max) * 100))}%`);
    slider.style.setProperty('--okg-max-percent', `${Math.max(0, Math.min(100, (maxValue / max) * 100))}%`);
  };

  const fillPriceInputs = (slider, minRange, maxRange) => {
    [
      [minRange, Number(minRange.value) || 0],
      [maxRange, Number(maxRange.value) || Number(maxRange.max) || 0],
    ].forEach(([range, value]) => {
      const target = document.getElementById(range.dataset.okgPriceTarget);
      if (target && target.value === '') target.value = formatPriceInputValue(value);
    });
    cleanPriceInputs(slider);
  };

  const syncSlider = (slider, changedRange) => {
    const minRange = slider.querySelector(minRangeSelector);
    const maxRange = slider.querySelector(maxRangeSelector);
    if (!minRange || !maxRange) return;

    let minValue = Number(minRange.value) || 0;
    let maxValue = Number(maxRange.value) || 0;

    if (minValue > maxValue) {
      if (changedRange === minRange) {
        maxValue = minValue;
        maxRange.value = String(maxValue);
      } else {
        minValue = maxValue;
        minRange.value = String(minValue);
      }
    }

    [
      [minRange, minValue],
      [maxRange, maxValue],
    ].forEach(([range, value]) => {
      const target = document.getElementById(range.dataset.okgPriceTarget);
      if (!target) return;

      target.value = formatPriceInputValue(value);
      target.dispatchEvent(new Event('input', { bubbles: true }));
    });

    updateSliderTrack(slider, minRange, maxRange);
  };

  document.addEventListener('input', (event) => {
    const range = event.target.closest(`${minRangeSelector}, ${maxRangeSelector}`);
    if (!range) return;

    const slider = range.closest(sliderSelector);
    if (slider) syncSlider(slider, range);
  });

  const init = () => {
    syncMissingFilterInputValues();
    syncCollectionStyleNav();

    document.querySelectorAll(sliderSelector).forEach((slider) => {
      const minRange = slider.querySelector(minRangeSelector);
      const maxRange = slider.querySelector(maxRangeSelector);
      if (minRange && maxRange) {
        fillPriceInputs(slider, minRange, maxRange);
        updateSliderTrack(slider, minRange, maxRange);
      }
    });
  };

  let frame = null;
  const scheduleInit = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = null;
      init();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  const facetsForm = document.querySelector('facet-filters-form');
  if (facetsForm) {
    new MutationObserver(scheduleInit).observe(facetsForm, {
      childList: true,
      subtree: true,
    });
  }
})();
